import { Locales } from 'locale';
import { LanguageCode, isLanguageCode } from '@osmosis/shared/languages';

import { IncomingHttpHeaders } from 'http';

export const ACCEPT_LANGUAGE = 'accept-language';

/**
 * Gets the accept language header.
 */
export const getAcceptLanguage = (
  headers: IncomingHttpHeaders,
): string | undefined => headers[ACCEPT_LANGUAGE];

/**
 * Use locale to pull the best language to support.
 */
export const getBestLanguage = (
  headersAcceptLanguage?: string | null,
): LanguageCode => {
  const supportedLocales = new Locales(['en-US', 'en', 'es']);
  const locales = new Locales(headersAcceptLanguage || undefined);
  const bestLocale = locales.best(supportedLocales);

  const language = bestLocale.language;
  if (isLanguageCode(language)) {
    return language;
  }
  return LanguageCode.EN;
};

/**
 * Get the language from the headers, user, or route.
 */
export const getLanguage = (
  headersAcceptLanguage?: string | null,
  userLanguage?: LanguageCode | null,
  routeLanguage?: LanguageCode | null,
): LanguageCode => {
  const bestLanguage = getBestLanguage(headersAcceptLanguage);
  return routeLanguage || userLanguage || bestLanguage;
};
